'use client';

import { ReactNode, useRef, useState } from 'react';

import { SideDrawer } from '@libs/shared-ui';

import { AccountButton } from '../../../shared';
import { useAccountAuthenticated } from '../../use-account-authenticated';

import './drawer.scss';

type DrawerProps = {
    children: (helper: { close: () => void }) => ReactNode;
};

export function Drawer({ children }: DrawerProps) {
    const triggerRef = useRef<HTMLButtonElement | null>(null);
    const [isOpen, setIsOpen] = useState(false);
    const { firstName } = useAccountAuthenticated();

    const focusTrigger = () => requestAnimationFrame(() => triggerRef.current?.focus());
    const close = () => setIsOpen(false);

    return (
        <>
            <AccountButton ref={triggerRef} onClick={() => setIsOpen(true)} />

            <SideDrawer isOpen={isOpen} onOpenChange={setIsOpen} onClose={focusTrigger}>
                <SideDrawer.Header>
                    <SideDrawer.Title className="account-authenticated-drawer__title">
                        Hi, <span className="account-authenticated-drawer__capitalize">{firstName}</span>!
                    </SideDrawer.Title>
                </SideDrawer.Header>
                <SideDrawer.Body>{children({ close })}</SideDrawer.Body>
            </SideDrawer>
        </>
    );
}
